import { render, staticRenderFns } from "./InfoComponents.vue?vue&type=template&id=b486195a&scoped=true"
import script from "./InfoComponents.vue?vue&type=script&lang=js"
export * from "./InfoComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b486195a",
  null
  
)

export default component.exports